module.exports = __webpack_public_path__ + "static/media/eduOrange.f9a29aac.svg";